import {Component, OnInit} from '@angular/core';
import {TermsAndConditionsStockistService} from '../../../shared/services/terms-and-conditions-stockist.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class StockistTermsConditionsComponent implements OnInit {
  submitting = false;
  termsAndConditions: any;

  constructor(public termsAndConditionsService: TermsAndConditionsStockistService) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.get();
  }

  get(params: any = {}) {
    this.submitting = true;
    this.termsAndConditionsService.get(params).subscribe(data => {
      if (data) {
        this.termsAndConditions = data;
        this.triggerScroll();
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }
}
